export default {
  currentPlan: {
    en: 'Your current plan',
  },
}
